import axios from "axios";
import React, { useState } from "react";
import Logo from "../../assets/Doorstep_logo.png";
import { useNavigate } from "react-router-dom";

function SubAdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();  // Used for navigation

  const login = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "/api/admin/loginsubadmin",
        { email, password },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.status === 200) {
        alert("Login successful!");
        sessionStorage.setItem("subAdmin", JSON.stringify(response.data.subAdmin));
        navigate("/SubAdminLeadManage"); // Redirect after login
      }
    } catch (error) {
      alert(error.response?.data?.message || "Invalid email or password");
      console.log(error);
    }
  };

  return (
    <div style={{ background: "#fff" }}>
      <div className="container pt-5 pb-5">
        <div className="row" style={{ padding: "10px 10px" }}>
          <div className="col-md-3" style={{ padding: "10em 0px" }}></div>
          <div className="col-md-6">
            <form onSubmit={login}>
              <div className="row">
                <div className="col-md-12 text-center">
                  <img src={Logo} height="150px" width="150px" alt="Logo" />
                  <h5 style={{ marginTop: "15px", fontSize: "2rem", color: "Navyblue" }}>
                    <span>Sub-Admin Sign In</span>
                  </h5>
                </div>
                <div className="col-md-12">
                  <div className="form-group pb-2">
                    <label className="fw-bold">Email ID</label>
                    <input
                      className="form-control"
                      type="email"
                      placeholder="Enter Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group pb-2">
                    <label className="fw-bold">Password</label>
                    <input
                      className="form-control"
                      type=""
                      placeholder="Enter Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12 pt-2">
                  <button
                    type="submit"
                    className="btn btn-primary form-control"
                    style={{
                      background: "Navyblue",
                      height: "60px",
                      fontSize: "20px",
                      fontWeight: "600",
                    }}
                  >
                    Sign In
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubAdminLogin;
